import { motion, useAnimate } from 'motion/react'
import { useEffect } from 'react'
import { Jobibot } from './jobibot'

export function JobiLoader({ scale = 1 }: { scale?: number }) {
	const [scope, animate] = useAnimate()

	useEffect(() => {
		animate('.eyes', {
			scaleY: [1, 0, 1],
			scaleX: [1, 1.2, 1],
		}, {
			repeat: Infinity,
			repeatType: 'mirror',
			duration: 0.2,
			repeatDelay: 2.7,
			ease: 'circOut',
		})

		try {
			animate('.antenna-christmas', {
				x: [0, -0.3, 0.3, 0],
				y: [0, -3, -2, 0],
			}, {
				repeat: Infinity,
				repeatType: 'mirror',
				duration: 3,
				repeatDelay: 2,
				delay: 0,
				ease: [0.4, 0, 0.6, 1],
			})
		} catch (e) {
			// do nothing
		}

		try {
			animate('.antenna', {
				// rotate: [0, '30deg', '-30deg', '0deg'],
				rotate: ['-20deg', '20deg'],
			}, {
				repeat: Infinity,
				repeatType: 'mirror',
				duration: 1,
				repeatDelay: 0,
				delay: 1,
				// ease: 'easeInOut',
				type: 'spring',
				damping: 10,
				stiffness: 100,
			})
		} catch (e) {
			// do nothing
		}
		animate('.eye-container', {
			y: [0, -2, 0],
		}, {
			repeat: Infinity,
			repeatType: 'mirror',
			duration: 1,
			repeatDelay: 2,
			delay: 1.2,
			ease: 'circOut',
		})

		animate('.jobibot', {
			rotateZ: [0, '-3deg', 0],
		}, {
			repeat: Infinity,
			repeatType: 'mirror',
			duration: 1,
			repeatDelay: 2,
			delay: 1.2,
			ease: 'circOut',
		})
	}, [])

	return (
		<div className="relative" style={{ transform: `scale(${scale})` }}>
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 0.5, delay: 0 }}
				className="absolute left-1/2 top-1/2 -translate-x-1/2 translate-y-[calc(-50%+5px)]"
			>
				<div className="jobiloader">
				</div>
			</motion.div>
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 0.5, delay: 0 }}
				className="absolute left-1/2 top-1/2 -translate-x-1/2 translate-y-[calc(-50%+5px)]"
			>
				<div className="jobiloader2">
				</div>
			</motion.div>
			<motion.div
				initial={{ opacity: 0, scale: 0.7 }}
				animate={{ opacity: 1, scale: 1 }}
				transition={{ duration: 0.2, ease: 'easeInOut' }}
			>
				<motion.div
					className="relative"
					ref={scope}
				>
					<Jobibot />
				</motion.div>
			</motion.div>
		</div>
	)
}
